<script setup>
// core
import {useStore} from "vuex";
import {computed, ref, getCurrentInstance} from 'vue';
import {useI18n} from "vue-i18n";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import CallNumberView from "@/components/Telephony/CallNumberView.vue";

// validate
import {validateSipName} from "@/helpers/dialogValidation";

const store = useStore()
const {proxy} = getCurrentInstance()
const {t: $t} = useI18n()
const info = computed(() => store.state.dialogParams?.info)

const extensionName = ref('')
const isLoading = ref(false)

const error = computed(() => validateSipName(extensionName.value, $t))
const isSubmittable = computed(() => !!extensionName.value.trim() && !error.value)

const onSubmit = async () => {
    if (!isSubmittable.value) return

    isLoading.value = true

    try {
        await store.dispatch('telephony/createExtension', {
            name: extensionName.value,
            number: info.value?.number,
            moshaToast: proxy.$moshaToast,
        })

        if (!!store.getters.getNextDialog) {
            store.commit("setDialog", store.getters.getNextDialog);
            store.commit("setNextDialog", "");
        } else {
            store.commit("closeDialog");
        }
    } finally {
        isLoading.value = false
    }
}
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ $t('telephony.sip.create_title') }}
            <div class="number-block">
                <CallNumberView :number="info?.number"/>
            </div>
        </h3>

        <form class="content" @submit.prevent="onSubmit">
            <div class="field">
                <p class="subtitle">{{ $t('telephony.sip.name_label') }}</p>
                <input
                    v-model="extensionName"
                    :class="{ input_error: !!error }"
                    :placeholder="$t('telephony.sip.name_placeholder')"
                />
                <div class="input-errors" :class="{ 'is-shown': !!error }">{{ error }}</div>
            </div>

            <div class="action_container">
                <ButtonLoading type="submit" :loading="isLoading" :disabled="isLoading || !isSubmittable">
                    {{ $t('common.save') }}
                </ButtonLoading>
            </div>
        </form>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
